export const noty = {
  done: 'Данные успешно изменены',
  error: 'Что-то пошло не так',
  link_copied: 'Ссылка скопирована',
  text_copied: 'Скопировано',
  export_started:
    'Мы подготавливаем для вас детализацию статистики. Вы получите уведомление со ссылкой на скачивание, когда файл будет готов.',
  export_pbx:
    'Мы подготавливаем для вас архив записей. Вы получите уведомление со ссылкой на скачивание, когда файл будет готов.'
};
